import Consumer from './QueriesConsumer'
import generateContextHOC from 'onyx-common/generateContextHOC'

export default generateContextHOC(Consumer, 'queries')
